module.exports = "<mat-card-title>{{ title }}</mat-card-title>\n<mat-card-content>\n  {{ firstMessage }}\n  <ng-container *ngIf=\"msgList\">\n    <p *ngFor=\"let msg of msgList\"> {{ msg }}</p>\n  </ng-container>\n</mat-card-content>\n\n<div class=\"centrarBotones\">\n  <button style=\"margin-right: 10px;\" type=\"button\" mat-raised-button color=\"accent\"\n    (click)=\"dialogRef.close(true)\">OK</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/modals/modal-message-dialog.component.html
// module id = ./src/app/shared-components/modals/modal-message-dialog.component.html
// module chunks = main